// @ts-nocheck
// #ifndef MP
import { useCommonStore } from '@/stores/modules/common'

// 处理hbuilder打包app之后点击手机返回键直接退出app的问题
let first = null
document.addEventListener('plusready', function () {
  plus.key.addEventListener('backbutton', function () {
    const commonStore = useCommonStore()
    // 获取当前路由
    const currentPath = commonStore.path
    if (['Home', 'Start'].includes(currentPath)) {
      // 首页返回键处理，1秒内，连续两次按返回键，则退出应用
      if (!first) {
        first = new Date().getTime()
        ElMessage.info('😫再按一次退出游戏')
        setTimeout(function () {
          first = null
        }, 1000)
      } else {
        if (new Date().getTime() - first < 1500) {
          plus.runtime.quit()
        }
      }
    } else {
      if (commonStore.isSocketInit) {
        commonStore.path = 'Home'
      } else {
        commonStore.path = 'Start'
      }
    }
  })
})
// #endif
